import { APP_SETTINGS } from './settings';
import { geoProcessor } from './useEsriLoader';

const { GIS_SERVER } = APP_SETTINGS;
const { GP } = GIS_SERVER;
let controller;

const queryPopupContain = async (mapPoint, activeOverlays, spinner) => {
  if (controller) {
    controller.abort();
    spinner.hide();
  }
  controller = new AbortController();
  const signal = controller.signal;
  spinner.show({
    location: mapPoint,
  });
  const gpPopupService = await geoProcessor(GP.POPUP_INFO_URL);
  const { x, y } = mapPoint;
  const params = {
    input_string: {
      ...activeOverlays,
      point_geometry: {
        x: x,
        y: y,
        spatialReference: { wkid: 27700 },
      },
    },
  };

  const { results } = await gpPopupService.execute(params, {
    signal,
  });

  const { value: popupContain } = results[0];
  spinner.hide();

  return popupTemplate(popupContain);
};

const popupTemplate = (popupContain) => {
  const scaKeys = Object.keys(popupContain);

  const tableHeader = (label) => {
    return `<th class="esri-feature-fields__field-header border"><span class="font-bold">${label}</span></th>`;
  };

  const tableData = (data) => {
    return `<td class="esri-feature-fields__field-data border"><span class="font-bold">${data}</span></td>`;
  };

  const tableRow = (rows) => {
    if (rows['popup_keys']) {
      return `${rows['popup_keys']
        .map(
          (label) =>
            `<tr>${tableHeader(rows['popup_labels'][label])} ${tableData(
              rows['popup'][label]
            )}</tr>`
        )
        .join('')}`;
    }
    return ``;
  };

  const table = (title, item) => {
    if (item['popup_keys']) {
      const titleWithoutSpace = title.replace(/_/g, ' ');
      return `<p class="font-bold">${
        item['popup_keys'].length ? titleWithoutSpace : ``
      }</p><table class="esri-widget__table mb-3"><tbody>${tableRow(
        item
      )}</tbody></table>`;
    }
    return ``;
  };

  const popup = `${scaKeys
    .map((key) => `${table(key, popupContain[key])}`)
    .join('')}`;

  return popup;
};

export { queryPopupContain };
